import { createListCollection } from '@chakra-ui/react';
import i18next, { t } from 'i18next';

export const collectionFrequency = createListCollection({
  items: [
    {
      label: t('library.selectValues.collectionFrequency.year'),
      value: 'year',
    },
    {
      label: t('library.selectValues.collectionFrequency.semester'),
      value: 'semester',
    },
    {
      label: t('library.selectValues.collectionFrequency.trimester'),
      value: 'trimester',
    },
  ],
});

export const trajectory = createListCollection({
  items: [
    { label: t('library.selectValues.trajectory.increase'), value: 'increase' },
    { label: t('library.selectValues.trajectory.decrease'), value: 'decrease' },
    { label: t('library.selectValues.trajectory.steady'), value: 'steady' },
  ],
});

export const category = createListCollection({
  items: [
    { label: t('library.selectValues.category.simple'), value: 'simple' },
    {
      label: t('library.selectValues.category.qualitative'),
      value: 'qualitative',
    },
    { label: t('library.selectValues.category.composite'), value: 'composite' },
  ],
});

export const indicatorColumnsDef = [
  {
    accessorKey: 'name',
    header: () => i18next.t('suggestion.columnsHeader.indicatorName'),
    sortable: true,
  },
  {
    accessorKey: 'commitment_suggestion_name',
    header: () => i18next.t('suggestion.columnsHeader.commitmentName'),
    sortable: true,
  },
  {
    accessorKey: 'pillar_suggestion_name',
    header: () => i18next.t('suggestion.columnsHeader.pillarName'),
    sortable: true,
  },
  {
    accessorKey: 'description',
    header: () => i18next.t('suggestion.columnsHeader.description'),
    sortable: false,
  },
  {
    accessorKey: 'category',
    header: () => i18next.t('suggestion.columnsHeader.categoryName'),
    sortable: false,
  },
  {
    accessorKey: 'lt_indicator_other_unit',
    header: () => i18next.t('suggestion.columnsHeader.unit'),
    sortable: true,
  },
  {
    accessorKey: 'sdgs',
    header: () => i18next.t('suggestion.columnsHeader.sdgs'),
    sortable: false,
  },
  {
    accessorKey: 'updated_at',
    header: () => i18next.t('suggestion.columnsHeader.updatedAt'),
    sortable: true,
  },
];

export const actionColumnsDef = [
  {
    accessorKey: 'name',
    header: () => i18next.t('suggestion.columnsHeader.actionName'),
    sortable: true,
  },
  {
    accessorKey: 'commitment_suggestion_name',
    header: () => i18next.t('suggestion.columnsHeader.commitmentName'),
    sortable: true,
  },
  {
    accessorKey: 'pillar_suggestion_name',
    header: () => i18next.t('suggestion.columnsHeader.pillarName'),
    sortable: true,
  },
  {
    accessorKey: 'description',
    header: () => i18next.t('suggestion.columnsHeader.description'),
    sortable: false,
  },
  {
    accessorKey: 'sdgs',
    header: () => i18next.t('suggestion.columnsHeader.sdgs'),
    sortable: false,
  },
  {
    accessorKey: 'updated_at',
    header: () => i18next.t('suggestion.columnsHeader.updatedAt'),
    sortable: true,
  },
];
